import { render } from "./KubernetesInstallation3.vue?vue&type=template&id=5feaf9f4"
import script from "./KubernetesInstallation3.vue?vue&type=script&lang=js"
export * from "./KubernetesInstallation3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__